import React from 'react';

function DataStudio() {
  const params = new URLSearchParams(window.location.search);
  const report = params.get('rid');
  const url = `https://datastudio.google.com/embed/reporting/${report}`;

  return (
    <main className="bg-white power-bi">
      <iframe
        title="asdflkjasdflkjasd"
        src={url}
        frameBorder="0"
        style={{
          border: 0,
          flexGrow: 1,
          width: '100%',
          height: '100%',
        }}
        allowFullScreen
      />
    </main>
  );
}

export default DataStudio;
